import { createContext } from "react"
import { defaultFeedContextValue } from "./defaultFeedContextValue"
import type { FeedContextValue } from "./FeedContextValue"

export const FeedContext = createContext<FeedContextValue>(
  defaultFeedContextValue,
)
